<template>
  <div ref="wrapper"
       v-if="isVisible"
       class="zoom-slider-wrapper"
  />
</template>

<script>
  import ZoomSliderControl from './zoom-slider-control';

  export default {
    name: 'ZoomSliderWrapper',
    inject: ['viewport', 'userPrefs'],
    data () {
      return { isRendered: false };
    },
    computed: {
      isVisible () {
        return this.userPrefs.us_zoomSlider.value;
      }
    },
    methods: {
      renderSlider () {
        if (!this.isRendered) {
          this.isRendered = true;
          return new ZoomSliderControl(this.viewport, this.userPrefs, this.$refs.wrapper);
        }
      }
    },
    watch: {
      isVisible () {
        if (this.isVisible) {
          this.$nextTick(() => {
            this.renderSlider();
            this.viewport.overLayout.refreshPrecinct('BL');
          });
        } else {
          this.isRendered = false;
        }
      }
    },
    mounted () {
      this.renderSlider();
    }
  };
</script>

<style scoped lang="scss">
.zoom-slider-wrapper {
  min-height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/uScope/js/extensions/zoom/ZoomSliderWrapper.vue